import $ from 'jquery'

import bus from '@/bus'
import * as nativeBridge from '@/native-bridge'
import store from '@/store'

export function navigationGuard(to) {
    store.dispatch('SET_CLOSEABLE', true)
    store.dispatch('STOP_LOADING')
    store.dispatch('SET_PAGE_TITLE', '')
    store.dispatch('CLOSE_LEFT_DRAWER')
    $('body').removeClass('modal-open')
    $('body .modal-backdrop').remove()
    if (to.meta.requiresAuth && !store.state.user) {
        return '/login?next=' + encodeURIComponent(to.path)
    }

    // MFA past its deadline and not set up: setup is the only signed-in page.
    // Setup is web-only, so the app is told to sign out instead.
    const mfaSetup = store.state.user && store.state.user.mfa_setup
    if (to.meta.requiresAuth && mfaSetup && mfaSetup.enforced && to.name !== 'mfa-setup') {
        if (nativeBridge.isNativeHost()) {
            nativeBridge.post({ type: 'logout', reason: 'mfa_enrollment_required' })
            return false
        }
        return { name: 'mfa-setup' }
    }

    // Route params are deliberately not forwarded: the native shell only ever read
    // the destination name (to close itself on a return to login), and the params
    // carried record IDs across the bridge for no consumer.
    nativeBridge.post({ type: 'route', name: to.name, path: to.path })

    bus.onNavigation()
}
